<template>
	<div class="digital digitalfactory">
		<MyHeader title="" />
		<div class="page-left">
			<Part1 class="mt-20" />
			<Part2 class="mt-20" />
			<Part3 class="mt-20" />
		</div>
		<div class="page-center">
			<div class="page-center-top"></div>
			<div class="page-center-bottom">
				<div class="zhezhao"></div>
					<video width="4576px" height="2255px" class="videoDigital" muted autoplay loop
						src="https://sass.gclme.com/web-video/factory.mp4"></video>

			</div>
		</div>
		<div class="page-right">
			<Part6 class="mt-10" />
			<Part4 class="mt-100" />
			<Part5 class="mt-50" />
		</div>
	</div>
</template>

<script>
	// import MyCenter from './center.vue'
	import Part1 from './digitalfactoryPart/Part_1.vue'
	import Part2 from './digitalfactoryPart/Part_2.vue'
	import Part3 from './digitalfactoryPart/Part_3.vue'
	import Part4 from './digitalfactoryPart/Part_4.vue'
	import Part5 from './digitalfactoryPart/Part_5.vue'
	import Part6 from './digitalfactoryPart/Part_6.vue'
	// import TopTitle from './../../components/TopTitle.vue'
	// import MyNumber from '../../components/myNumbers.vue'
	import MyHeader from '../../computility/components/myHeader';

	export default {
		components: {
			MyHeader,
			// MyCenter,
			Part1,
			Part2,
			Part3,
			Part4,
			Part5,
			Part6,
			// TopTitle,
			// MyNumber,
		},
		data() {
			return {
				pageInterval: null,
				intervalNum: 60
			}
		},
		mounted() {

			if(this.pageInterval) {
				clearInterval(this.pageInterval)
				this.pageInterval = null
			}
			// if(sessionStorage.getItem('fromUser') != 'guizhou' && sessionStorage.getItem('fromUser') != 'suzhou') {
			// this.pageInterval = setInterval(() => {
			// 	this.intervalNum--
			// 	if(this.intervalNum < 0 ) {
			// 	this.$router.replace({
			// 		// path: 'exposition2th',
			// 		path: 'HashPowerMerging'
			// 	})
			// 	}
			// }, 1000)

			// document.onmousemove = (() => {
			// 	this.intervalNum = this.intervalNumSet
			// })
			// }
		},
		destroyed() {
			clearInterval(this.pageInterval)
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/scss/comm.scss';

	$HeaderHeight: 245px;
	$WidthPage: 967px;

	// .disNumber{
	//     position: absolute;
	//     top: 200px;
	// }

	// .digital {
	// 	width: 100%;
	// 	height: 1000%;
	// 	background: url(~@/assets/images/digitalfactory/digitalfactory-bg.png) no-repeat;
	// 	background-size:100% 100% ;
	// }


	.digitalfactory {
		.header-box{
			height: 330px;
			width: 4576px;
		}
		// display: flex;
		position: relative;
		width: 100%;
		height: 100%;
		// background: url(~@/assets/images/digitalfactory/digitalfactory-bg.png) no-repeat;
		// background-size:100% 100% ;
		// padding: 0 65px;
		// box-sizing: border-box;
		.page-left,
		.page-right {
			width: $WidthPage;
			position: absolute;
			top: $HeaderHeight;
			height: calc(100% - $HeaderHeight);
			z-index: 10;
			z-index: 10000;
			// background: red;
		}

		.page-left {
			left: 50px;
			// background-color: red;
		}

		.page-right {
			right: 50px;
			// background-color: aqua;
		}

		.page-center {
			// background-color: pink;
			position: absolute;
			top: 50px;
			left: 0;
			// flex: 1;
			text-align: center;
			height: 100%;
			width: 100%;
			.page-center-top {
				// height: 250px;
				// background-color: red;
			}

			.page-center-bottom {
				height: 1934px;
				position: relative;
				top: -100px;
				z-index: 1;
				// background-color:pink;
				.zhezhao {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					// background-color: pink;
					// height: 1934px;
					height: 2255px;
					// background-image: url("~@/assets/images/exposition/zhezhaoceng.png");
					background: url(~@/assets/images/digitalfactory/digitalfactory-bg.png) no-repeat;
					background-size: 100% 100%;
					z-index:2;
				}
				.videoDigital{
					position: absolute;
					top: 0;
					left: 0;
					// width: 100%;
					// background-color: pink;
					// height: 1934px;
					z-index:1;
				}
			}

		}
	}
</style>